import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, StepIcon, useTheme } from "@mui/material";
import { applyTokens } from "../../../utilities/applyTokens.js";
import { createLazyIcon } from "../../../utilities/createLazyIcon.js";
const CheckedIcon = createLazyIcon(() => import("@diligentcorp/atlas-react-icons/dist/esm/lens/Checked.js"));
function CompletedStepIcon(props) {
    const { completed } = props;
    const { tokens: { semantic, component }, } = useTheme();
    const { stepper } = component;
    return (_jsx(_Fragment, { children: completed ? (_jsx(Box, Object.assign({ sx: Object.assign(Object.assign({}, applyTokens(stepper.step.icon.completed)), { width: stepper.step.icon.width.value, height: stepper.step.icon.height.value, borderRadius: semantic.radius.full.value, display: "flex", alignItems: "center", justifyContent: "center" }) }, { children: _jsx(CheckedIcon, {}) }))) : (_jsx(StepIcon, Object.assign({}, props))) }));
}
const stepper = (tokens) => {
    const { stepper } = tokens.component;
    return {
        MuiStepper: {
            styleOverrides: {
                root: Object.assign({}, applyTokens(stepper)),
            },
        },
        MuiStep: {
            styleOverrides: {
                root: Object.assign(Object.assign({}, applyTokens(stepper.step)), { padding: 0 }),
            },
        },
        MuiStepLabel: {
            defaultProps: {
                StepIconComponent: CompletedStepIcon,
            },
            styleOverrides: {
                root: {
                    gap: stepper.step.gap.value,
                },
                iconContainer: {
                    padding: 0,
                },
                label: Object.assign(Object.assign({}, applyTokens(stepper.step.label)), { "&.Mui-active": {
                        fontWeight: stepper.step.label.active.fontWeight.value,
                    } }),
            },
        },
        MuiStepIcon: {
            styleOverrides: {
                root: Object.assign(Object.assign({}, applyTokens(stepper.step.icon)), { fill: stepper.step.icon.default.backgroundColor.value, "& text": Object.assign(Object.assign({}, applyTokens(stepper.step.icon.text)), { fill: stepper.step.icon.text.default.color.value }), "&.Mui-active": {
                        fill: stepper.step.icon.active.backgroundColor.value,
                        "& text": {
                            fill: stepper.step.icon.text.active.color.value,
                        },
                    } }),
            },
        },
        MuiStepConnector: {
            styleOverrides: {
                root: Object.assign(Object.assign({}, applyTokens(stepper.connector)), { flex: "none" }),
            },
        },
    };
};
export default stepper;
//# sourceMappingURL=stepper.js.map